export default class Flyout {
	constructor() {
		this.node = document.querySelector('.flyout');

		if ( ! this.node ) {
			return;
		}

		this.classes = {
			bodyOpened        : 'fixed',
			contentOpened     : 'flyout__content--opened',
			menuOpened        : 'flyout__submenu--opened',
			opened            : 'flyout--opened',
			toggleActive      : 'flyout__toggle--active',
			navHasToggleActive: 'flyout__nav--has-toggle-active',
			submenuActive	  : 'flyout__item--subchildactive',
			submenu 		  : 'flyout__item--subchild'

		};

		this.closer      = this.node.querySelector('.flyout__close');
		this.content     = this.node.querySelector('.flyout__content');
		this.modeToggle  = this.node.querySelector('.flyout__mode');
		this.nav         = this.node.querySelector('.flyout__nav');
		this.backs       = this.node.querySelectorAll('.flyout__back');
		this.toggles     = this.node.querySelectorAll('.flyout__toggle');
		this.searchInput = this.node.querySelector('input[name="s"]');
		this.childMenu	 = this.node.querySelectorAll('.flyout__link--child');
		this.primaryChildMenu	 = this.node.querySelectorAll('.flyout__menu--primary-child');

		this.modes = ['menu', 'search'];
		this.setMode('menu');

		if ( this.modeToggle ) {
			this.modeToggle.addEventListener('click', () => {
				if (this.mode === 'menu') {
					this.setMode('search');
					this.searchInput.focus();
				} else {
					this.setMode('menu');
				}
			});
		}


		if ( this.childMenu ) 
		this.childMenu.forEach(menu => {
			if(menu.children.length > 0)
				menu.addEventListener('click', (e) => {
					const item = menu.parentElement.querySelectorAll('.flyout__item--subchild');
					const activeitem = menu.parentElement.querySelectorAll('.flyout__item--subchildactive');

					if(!e.currentTarget.classList.contains(this.classes.submenuActive));
						e.preventDefault();

					for (let index = 0; index < item.length; index++) {
						if (!item[index].classList.contains(this.classes.submenuActive)) {
							item[index].classList.add(this.classes.submenuActive);
							item[index].classList.remove(this.classes.submenu);
						}
						else{
							item[index].classList.remove(this.classes.submenuActive);
							item[index].classList.add(this.classes.submenu);
						}
					}

					for (let index = 0; index < activeitem.length; index++) {
						if (!activeitem[index].classList.contains(this.classes.submenuActive)) {
							activeitem[index].classList.add(this.classes.submenuActive);
							activeitem[index].classList.remove(this.classes.submenu);
						}
						else{
							activeitem[index].classList.remove(this.classes.submenuActive);
							activeitem[index].classList.add(this.classes.submenu);
						}
					}
				});
		});

		if ( this.closer ) 
					this.closer.addEventListener('click', () =>  this.close());

		if ( this.searchToggle ) {
			this.searchToggle.addEventListener('click', () => this.mode('search'));
		}

		// handle esc/tab keys
		this.handleKeyup = (e) => {
			if (this.opened) {
				if ( e.key === 'Escape' ) {
					return this.close();
				}

				if (e.key === 'Tab' && ! document.activeElement.closest('.flyout')) {
					// close the flyout when you tab out of it (if possible)
					return this.close();
				}
			}
		}

		// handle close
		this.node.addEventListener('click', (e) => {
			if (e.target.closest('.flyout__content')) {
				return;
			}

			this.close();
		});

		const openSubmenu = (navItem) => {
			if ( ! navItem) {
				return;
			}
			navItem.classList.add(this.classes.menuOpened);
			navItem.style.height = `auto`;
			this.content.scrollTo(0,0);
		}

		const closeSubmenu = (navItem) => {
			if ( ! navItem ) {
				return;
			}
			navItem.classList.remove(this.classes.menuOpened);
			navItem.style.height = ``;
			this.content.scrollTo(0,0);
		}

		this.node.querySelectorAll('.flyout__submenu a, .flyout__submenu button').forEach( node => {
			node.dataset.tabIndex = node.tabIndex;
			node.tabIndex = -1;
		} );

		this.backs.forEach(back => {
			back.addEventListener('click', () => closeSubmenu(back.closest('.flyout__item')));
		});
		// set active class on the primary nav (personal/business)
		function setActiveTab(tab, isActive){
			if(isActive)
				tab.classList.add('tab-active');
			else
				tab.classList.remove('tab-active');
		}

		this.toggles.forEach( toggle => {
			// check the url to see if its a business page and set active class to the primary nav
			if (window.location.href.indexOf("/business-banking/") > -1) {
				setActiveTab(toggle, toggle.innerText == 'Business');
			}
			else
				setActiveTab(toggle, toggle.innerText == 'Personal');

			openSubmenu(this.primaryChildMenu[0]);
			toggle.addEventListener('click', (e) => {
				this.toggles.forEach( tg => {
					setActiveTab(tg, e.target.innerText === tg.innerText);
				});
                this.primaryChildMenu.forEach( child => {
                    if(child.getAttribute('data-menu') == toggle.innerText)
				        openSubmenu(child);
					else {
						if(!((child.getAttribute('data-menu') == 'Personal' || child.getAttribute('data-menu') == 'Business') && !(toggle.innerText == 'Personal' || toggle.innerText == 'Business')))
							closeSubmenu(child);
					}
                });
			});
		});
	}

	open(mode) {
		if (mode) {
			this.setMode(mode);
		}

		this.opened = true;
		this.node.style.display = 'block';
		document.body.classList.add(this.classes.bodyOpened);
		document.addEventListener('keyup', this.handleKeyup);

		this.disableTabs();

		this.previousActiveElement = document.activeElement;

		requestAnimationFrame( () => requestAnimationFrame( () => {
			this.node.classList.add(this.classes.opened);
			this.content.classList.add(this.classes.contentOpened);

			if (this.mode === 'search' && this.searchInput) {
				this.searchInput.focus();
			} else if ( this.closer ) {
				this.closer.focus();
			}

			this.node.dispatchEvent( new CustomEvent('flyout:open', { bubbles: true, cancelable: false } ) );
		} ) );
	}

	close() {
		this.opened = false;
		document.removeEventListener('keyup', this.handleKeyup);

		const onTransitionEnd = (e) => {
			this.content.removeEventListener('transitionend', onTransitionEnd);

			this.node.style.display = '';

			document.body.classList.remove(this.classes.bodyOpened);
			this.node.classList.remove(this.classes.opened);

			if (this.previousActiveElement) {
				this.previousActiveElement.focus();
			}

			this.enableTabs();

			this.node.dispatchEvent( new CustomEvent('flyout:close', { bubbles: true, cancelable: false }) );
		}

		this.content.addEventListener('transitionend', onTransitionEnd);
		this.content.classList.remove(this.classes.contentOpened);

	}

	toggle() {
		this.opened ? this.closeSearch() : this.openSearch();
	}

	setMode( mode = 'menu' ) {
		if ( ! this.modes.includes( mode ) ) {
			return this.mode;
		}

		this.mode = mode;

		this.modes.forEach( m => {
			if ( mode === m ) {
				this.node.classList.add(`flyout--${m}`);
			} else {
				this.node.classList.remove(`flyout--${m}`);
			}
		} );

		return this.mode;
	}

	getTabs( scope = document ) {
		return Array.from(scope.querySelectorAll([
			'select',
			'input',
			'textarea',
			'button',
			'a',
			'iframe',
			'object',
			'embed',
			'*[contenteditable]',
			'*[tabindex]',
		].join(', '))).filter(node => {
			return ! node.closest('.flyout');
		});
	}

	disableTabs() {
		const tabs = this.getTabs();

		tabs.forEach(node => {
			let prevTabIndex = node.getAttribute('tabIndex');
			if (prevTabIndex) {
				node.setAttribute('data-tab-index', prevTabIndex);
			}

			node.setAttribute('tabIndex', '-1');
		});

		return tabs;
	}

	enableTabs() {
		const tabs = this.getTabs();

		tabs.forEach(node => {
			let prevTabIndex = node.getAttribute('data-tab-index');
			if (prevTabIndex) {
				node.setAttribute('tabIndex', prevTabIndex);
				node.removeAttribute('data-tab-index');
			} else {
				node.removeAttribute('tabIndex');
			}
		});

		return tabs;
	}
}
